import { Card, CardContent, CircularProgress } from "@mui/material";
import { snack } from "components/Snack/Snack";
import { useEffect, useState } from "react";
import { MdGroup } from "react-icons/md";
import { statsAdminService } from "services/admin/statsService";

const CustomersCount = ({ month }) => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    loadData()
  }, [month])

  async function loadData() {
    try {
      setLoading(true)
      const result = await statsAdminService.getCustomersCount({ month })
      setData(result.data)
    } catch (ex) {
      console.error(`CustomersCount ex: `, ex)
      snack(ex?.message)
      setError(ex?.message)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return <div className="text-center"><CircularProgress></CircularProgress></div>
  }

  if (error) {
    return <div>{error}</div>
  }

  return (
    <Card style={{ backgroundColor: 'var(--card-background-color)' }} className="stat-card">
      <CardContent>
        <div className="text-center">
          <MdGroup size="42" style={{ color: 'rgba(83, 155, 255)' }}></MdGroup>
          <h4 className="text-info">Количество клиентов</h4>
          <h4 className="text-info mt-1">{data || 0}</h4>
        </div>
      </CardContent>
    </Card>
  );
};

export default CustomersCount
